import path from 'ramda/src/path'
import moduleDescriptions from 'root/src/shared/descriptions/modules'
import stepIdSelector from 'root/src/client/logic/form/selectors/stepIdSelector'

export default (state, { moduleId, stepId, moduleKey }) => {
	const stepIdMod = stepId || stepIdSelector(state, { moduleKey })
	return path([moduleId, 'steps', stepIdMod, 'isSingleStep'], moduleDescriptions)
}
